// @ts-nocheck
export default (blob: Blob, fileName: string, openInNewTab = false) => {
    const link = document.createElement("a");
    const documentUrl = URL.createObjectURL(blob);

    if (openInNewTab) {
        window.open(documentUrl, "_blank");
        return;
    }

    link.href = documentUrl;
    link.target = "_blank";
    link.download = fileName;

    document.body.append(link);

    link.click();
    link.remove();

    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};
